import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../../services/tenant/tenant.service';
import { AppStorage } from '../../../../core/common/enums/app-storage';
import { AUTH_ROUTES } from '../../../../core/common/constants/auth.routing.constants';
import { CookieService } from '../../services/cookie/cookie.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tenantService = inject(TenantService);
  const cookieService = inject(CookieService);

  const isTokenPresent = !!cookieService.get(AppStorage.token);

  if (!isTokenPresent) {
    const queryParamArray = location.search.replace('?', '').split('=');
    const queryParamObject = { [queryParamArray[0]]: queryParamArray[1] };

    return router.createUrlTree([tenantService.authPath(AUTH_ROUTES.LOGIN)], {
      queryParams: {
        target: location.pathname,
        ...queryParamObject,
      },
    });
  }

  return isTokenPresent;
};
